import appSettings from "../utils/AppSetting";
import useAxios from "../utils/UseAxios";

const ContractorBillingService = () => {
  const baseUrl = `${appSettings.services.CMGateWay.apiUrl}`;
  const apiPermGroupCode = `${appSettings.services.ContractorBillingApi.apiPermGroupCode}`;
  const { loading, error, post } = useAxios(baseUrl, {}, apiPermGroupCode);

  var cmGatewayController = "/cm";
  var tmsGatewayController = "/tms";

  let token = localStorage.getItem("access_token");

  const ValidationInformation = async (param) => {
    try {
      const response = await post(
        `${cmGatewayController}/InformationValidation`,
        param,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

   const ValidateOTP = async (param) => {
    try {
          const response = await post(`${cmGatewayController}/ValidateOTP`, param, {
        headers: {
          Authorization: token,
        },
      });
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };
  const ChangePassword = async (param) => {
    try {
      const response = await post(
        `${cmGatewayController}/PasswordChange`,
        param,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

  const SendEmail = async (param) => {
    try {
      const response = await post(`${cmGatewayController}/EmailSend`, param, {
        headers: {
          Authorization: token,
        },
      });
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

   const ReSendEmail = async (param) => {
    try {
       const response = await post(`${cmGatewayController}/ReSendOTP`, param, {
        headers: {
          Authorization: token,
        },
      });
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

  const ListMenu = async (param) => {
    try {
      const response = await post(
        `${cmGatewayController}/AuthListMenu`,
        param,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

  const GetOrganizeList = async (param) => {
    try {
      const response = await post(
        `${cmGatewayController}/OrganizeList`,
        param,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

  const GetWorkerList = async (param) => {
    try {
      const response = await post(`${cmGatewayController}/WorkerList`, param, {
        headers: {
          Authorization: token,
        },
      });
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

  const GetConfig = async (param) => {
    try {
      const response = await post(`${tmsGatewayController}/Config_Get`, param, {
        headers: {
          Authorization: token,
        },
      });
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

  const GetBilling = async (param) => {
    try {
      const response = await post(`${cmGatewayController}/BillingGet`, param, {
        headers: {
          Authorization: token,
        },
      });
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

  const GetBillingList = async (param) => {
    try {
      const response = await post(
        `${tmsGatewayController}/Billing_List`,
        param,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

  const GetQueueDetail = async (param) => {
    try {
      const response = await post(
        `${tmsGatewayController}/QueueDetail_Get`,
        param,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

  const GetSpecialBilling = async (param) => {
    try {
      const response = await post(
        `${cmGatewayController}/SpecialBillingList`,
        param,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

  const AddSpecialBill = async (param) => {
    try {
      const response = await post(
        `${tmsGatewayController}/SpecialBilling_Add`,
        param,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

  const CancelSpecialBill = async (param) => {
    try {
      const response = await post(
        `${tmsGatewayController}/Billing_Cancel`,
        param,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

  const ListHistoryBilling = async (param) => {
    try {
      const response = await post(
        `${cmGatewayController}/BillingHistoryList`,
        param,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response;
    } catch (error) {
      console.error("Error posting data:", error);
      throw error;
    }
  };

  return {
    loading,
    error,
    ValidationInformation,
    ValidateOTP,
    ChangePassword,
    SendEmail,
    ReSendEmail,
    ListMenu,
    GetConfig,
    GetBilling,
    GetOrganizeList,
    GetWorkerList,
    GetBillingList,
    GetQueueDetail,
    GetSpecialBilling,
    AddSpecialBill,
    CancelSpecialBill,
    ListHistoryBilling,
  };
};
export default ContractorBillingService;
